import axios from '~/utils/axiosInstance';
import type { Company, CompanySubtypeCode } from '~/types/company';

export const updateCompanyName = async function (companyId: string, name: string) {
   const response = await axios.patch(`/company/${companyId}`, {name});
   return response.data;
};

export type RequestCompanyLogoUploadResponse = Company & { logoUploadPresignedUrl?: string };

/** Request presigned PUT URL for a new logo; client uploads the file to that URL, then refetches company. */
export async function requestCompanyLogoUpload(companyId: string, fileName: string) {
  const response = await axios.patch<RequestCompanyLogoUploadResponse>(`/company/${companyId}`, {
    fileName,
  });
  return response.data;
}

export const getCompany = async function (companyId: string) {
   const response = await axios.get(`/company/${companyId}`);
   return response.data;
};

export async function patchCompany(
  companyId: string,
  payload: {
    projectVisibility?: 'ALL' | 'INVITE_ONLY';
    subtypeCodes?: CompanySubtypeCode[];
    website?: string | null;
    active?: boolean;
  }
) {
  const response = await axios.patch(`/company/${companyId}`, payload);
  return response.data;
}

// Investor Profile API functions
export const createInvestorProfile = async function (payload: any) {
   const response = await axios.post('/company/investor-profile', payload);
   return response.data;
};

export const getAllInvestorProfiles = async function () {
   const response = await axios.get('/company/investor-profile');
   return response.data;
};

export const updateInvestorProfile = async function (profileId: string, payload: any) {
   const response = await axios.patch(`/company/investor-profile/${profileId}`, payload);
   return response.data;
};

export const getInvestorProfileById = async function (profileId: string) {
   const response = await axios.get(`/company/investor-profile/${profileId}`);
   return response.data;
};

export const getInvestorProfileByCompanyId = async function (companyId: string) {
   const response = await axios.get(`/company/${companyId}/investor-profile`);
   return response.data;
};

export const getInvestorProfileBadges = async function () {
   const response = await axios.get('/company/investor-profile/badges');
   return response.data;
};